// // AhaMomentAILanding.jsx
// import React, { useState, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { v4 as uuidv4 } from 'uuid';
// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import { logEvent } from '../utils/analytics/GoogleAnalytics';

// const AhaMomentAILanding = () => {
//   const [input, setInput] = useState('');
//   const navigate = useNavigate();
//   const chatEndRef = useRef(null);

//   const suggestions = [
//     'Help me learn basics of technical analysis?',
//     'Teach me how to interpret signals?',
//     'Help me choose a broker?',
//     'Help me understand basics of fundamental analysis?',
//   ];

//   const handleAskAI = () => {
//     if (!input.trim()) return;

//     const chatSessionId = uuidv4();
//     logEvent('aha_ask_ai_click', {
//       event_category: 'Aha Moment',
//       event_label: input.trim(),
//       value: 1,
//     });

//     navigate(`/learn/space/${chatSessionId}`, {
//       state: { question: input.trim() },
//     });
//   };

//   return (
//     <>
//       <Header />
//       <div style={{ background: '#232830', color: '#fff', minHeight: '100vh', paddingTop: '80px', fontFamily: 'Nunito Sans, sans-serif' }}>
//         <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 1rem' }}>
//           <h1 style={{ fontSize: '2.4rem', fontWeight: '800', textAlign: 'center', color: '#ffffff' }}>📈✨ What topics do you want to learn today ?</h1>
//           <p style={{ fontSize: '1.2rem', textAlign: 'center', marginBottom: '2rem', color: '#ffffff' }}>
//             Confused about a chart move or trading or investing concept? Just ask.
//           </p>

//           <div style={{ position: 'relative', marginBottom: '1rem' }}>
//             <textarea
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               placeholder="e.g. Why did BTC reverse from $72k?"
//               rows={5}
//               style={{
//                 width: '100%',
//                 padding: '1rem',
//                 borderRadius: '16px',
//                 fontSize: '1.1rem',
//                 border: '1px solid #ccc',
//                 outline: 'none',
//                 resize: 'vertical',
//                 fontFamily: 'Nunito Sans, sans-serif',
//               }}
//             />
//             <button
//               onClick={handleAskAI}
//               style={{
//                 position: 'absolute',
//                 bottom: '12px',
//                 right: '12px',
//                 padding: '0.75rem 1.25rem',
//                 fontWeight: '700',
//                 fontSize: '1rem',
//                 backgroundColor: '#FF7C24',
//                 color: '#fff',
//                 border: 'none',
//                 borderRadius: '10px',
//                 cursor: 'pointer',
//               }}
//             >
//               Ask AI
//             </button>
//           </div>

//           <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '2rem' }}>
//             {suggestions.map((text, index) => (
//               <button
//                 key={index}
//                 onClick={() => {
//                   setInput(text);
//                   logEvent('aha_suggestion_click', {
//                     event_category: 'Aha Moment',
//                     event_label: text,
//                     value: 1,
//                   });
//                 }}
//                 style={{
//                   padding: '0.6rem 1rem',
//                   backgroundColor: '#fff',
//                   color: '#232830',
//                   borderRadius: '12px',
//                   border: 'none',
//                   fontWeight: '600',
//                   cursor: 'pointer',
//                   fontFamily: 'Nunito Sans, sans-serif',
//                 }}
//               >
//                 {text}
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default AhaMomentAILanding;




import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { logEvent } from '../utils/analytics/GoogleAnalytics.js';
import { askAhaMomentAI } from '../api/askAhaMomentAI';
import { getAuth } from 'firebase/auth';

import { trackEvent } from '../utils/analytics/trackEvent.js';
import { useEffect } from 'react';


const AhaMomentAILanding = () => {
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const chatEndRef = useRef(null);
  const auth = getAuth();


  
  useEffect(() => {
    trackEvent('aha_page_view', {
      screen: 'AhaMomentAILanding',
      channel: 'web',
      timestamp: Date.now(),
    });
  }, []);


  const suggestions = [
    'Market Order?',
    'Liquidity?',
    'Chart patterns?',
    'Directional Bias',
  ];

  const handleAskAI = async () => {

    trackEvent('aha_ask_ai_button_clicked', {
      screen: 'AhaMomentAILanding',
      user_id: auth.currentUser?.uid || 'anonymous',
      channel: 'web',
      message_length: input.trim().length,
      timestamp: Date.now(),
    });
    
    

  if (!input.trim()) return;

  setLoading(true);

  const chatSessionId = uuidv4();
  const user = auth.currentUser;
  const userId = user?.uid || 'anonymous';
  const usermessage = input.trim();

   // ✅ GA4 Tracking
   trackEvent('aha_ask_ai_click', {
    screen: 'AhaMomentAILanding',
    user_id: userId,
    chatsessionid: chatSessionId,
    message_length: usermessage.length,
    channel: 'web',
    timestamp: Date.now(),
  });

  // ✅ Navigate immediately
  navigate(`/learn/space/${chatSessionId}`, {
    state: { question: usermessage },
  });

  // 🔁 Background AI fetch (don’t block navigation)
  askAhaMomentAI({
    userId,
    chatsessionid: chatSessionId,
    usermessage,
    messageCount: 0,
  })
    .then((airesponse) => {
      sessionStorage.setItem(`ahaResponse-${chatSessionId}`, JSON.stringify({
        question: usermessage,
        airesponse,
      }));
    })
    .catch((err) => {
      console.warn('AI fetch failed after navigation:', err);
    });

  // Optionally stop the loading state (or skip it since page is changing)
  setLoading(false);
};

  

  

  return (
    <>
      {/* <Header /> */}
      <div style={{ background: '#232830', color: '#fff', minHeight: '100vh', paddingTop: '80px', fontFamily: 'Nunito Sans, sans-serif' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 1rem' }}>
          <h1 style={{ fontSize: '2.4rem', fontWeight: '800', textAlign: 'center', color: '#ffffff' }}>📈✨ What Prop Trading Concepts do you want to learn today?</h1>
          <p style={{ fontSize: '1.2rem', textAlign: 'center', marginBottom: '2rem', color: '#ffffff' }}>
            Confused about smart money concepts? Just ask.
          </p>

          <div style={{ position: 'relative', marginBottom: '1rem' }}>
          <textarea
  value={input}
  onChange={(e) => setInput(e.target.value)}
  placeholder="e.g. Why did BTC reverse from $72k?"
  rows={5}
  style={{
    width: '100%',
    padding: '1rem',
    borderRadius: '16px',
    fontSize: '1.1rem',
    border: '1px solid #ccc',
    outline: 'none',
    resize: 'vertical',
    fontFamily: 'Nunito Sans, sans-serif',
    color: '#fff',
    backgroundColor: '#2C2F36',
  }}
/>
            <button
              onClick={handleAskAI}
              style={{
                position: 'absolute',
                bottom: '12px',
                right: '12px',
                padding: '0.75rem 1.25rem',
                fontWeight: '700',
                fontSize: '1rem',
                backgroundColor: '#FF7C24',
                color: '#fff',
                border: 'none',
                borderRadius: '10px',
                cursor: 'pointer',
              }}
            >
                {loading ? 'Thinking...' : 'Ask AI'}
            </button>
          </div>

          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '2rem' }}>
            {suggestions.map((text, index) => (
              <button
                key={index}
                onClick={() => {
                  setInput(text);
                  trackEvent('aha_suggestion_click', {
                    screen: 'AhaMomentAILanding',
                    topic: text,
                    user_id: auth.currentUser?.uid || 'anonymous',
                    channel: 'web',
                    timestamp: Date.now(),
                  });
                }}
                
                style={{
                  padding: '0.6rem 1rem',
                  backgroundColor: '#fff',
                  color: '#232830',
                  borderRadius: '12px',
                  border: 'none',
                  fontWeight: '600',
                  cursor: 'pointer',
                  fontFamily: 'Nunito Sans, sans-serif',
                }}
              >
                {text}
              </button>
            ))}
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default AhaMomentAILanding;

